export default function KpiCard({ label, value, unit, hint, accent, testid }) {
  return (
    <div className="hbt-card p-6 flex flex-col justify-between min-h-[132px]" data-testid={testid}>
      <div className="hbt-label">{label}</div>
      <div className="mt-4">
        <div className="flex items-baseline gap-2">
          <div className="font-display font-semibold text-3xl lg:text-[34px] tracking-tight leading-none font-mono-num" style={{ color: accent || "var(--forest)" }}>
            {value}
          </div>
          {unit && <div className="text-sm text-neutral-500 font-medium">{unit}</div>}
        </div>
        {hint && <div className="text-xs text-neutral-500 mt-2">{hint}</div>}
      </div>
    </div>
  );
}
